export const PRODUCTS_BY_BRAND: Record<string, string[]> = {
  'Promat': [
    'Promat PROMASEAL-A',
    'Promat PROMASEAL-AG',
    'Promat PROMASTOP-CC',
    'Promat PROMASTOP-W',
    'Promat LANA DI ROCCIA',
    'Promat PROMASTOP-FC MD',
    'Promat PROMASEAL-A Spray',
    'Promat PROMASTOP-FB',
    'Promat PROMATECT-L500',
  ],
  'AF Systems': [
    'AF Seal W',
    'AF Panel',
    'AF Pipeguard',
    'AF Sleeves',
    'AF Sleeve B3',
    'AF Brick',
    'AF Multicollar',
    'AF Collar',
    'AF Collar C',
    'AF Fireguard 3',
    'AF Safeguard',
    'AF Bags',
    'AF Junction Box'
  ],
  'Global Building': [
    'Global Building FireSeal',
    'Global Building FireStop',
    'Global Building FireProtect',
  ],
  'Hilti': [
    'Hilti CFS-IS',
    
  ],
};
